import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

const CreateEditReferenceRail = ({ main, reference, className, mainClassName }) => (
  <div
    className={cn(
      'grid min-h-0 grid-cols-1 gap-4',
      'lg:max-h-[var(--create-edit-sheet-height)] lg:flex-1',
      'lg:grid-cols-[minmax(0,1fr)_minmax(280px,360px)] lg:items-stretch',
      className,
    )}
  >
    <div className={cn('flex min-h-0 min-w-0 flex-col', mainClassName)}>{main}</div>
    <aside
      className={cn(
        'min-h-0 min-w-0 space-y-4',
        'lg:sticky lg:top-0',
        'lg:max-h-[var(--create-edit-sheet-height)]',
        'lg:overflow-y-auto lg:overscroll-y-contain',
      )}
    >
      {reference}
    </aside>
  </div>
);

CreateEditReferenceRail.propTypes = {
  main: PropTypes.node.isRequired,
  reference: PropTypes.node,
  className: PropTypes.string,
  mainClassName: PropTypes.string,
};

export default CreateEditReferenceRail;
